"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPC = exports.isiOS = exports.isAndroid = exports.LITBSITENAME = void 0;
var LITBSITENAME;
(function (LITBSITENAME) {
    LITBSITENAME["LITBMINI"] = "LITBMINI";
    LITBSITENAME["LITBADOR"] = "LITBADOR";
    LITBSITENAME["LITBOUKUU"] = "LITBOUKU";
})(LITBSITENAME = exports.LITBSITENAME || (exports.LITBSITENAME = {}));
exports.isAndroid = function () {
    var ua = window.navigator.userAgent;
    return ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
};
exports.isiOS = function () {
    var ua = window.navigator.userAgent;
    return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};
exports.isPC = function () {
    var ua = window.navigator.userAgent;
    if (!ua) {
        return false;
    }
    var isMobile = /^m([0-9]|-\w+|)\./g.test(location.hostname) ||
        ua.match(/iPhone|iPod|iPad|ios|Android|Windows Phone|SymbianOS/i);
    return !isMobile;
};
